const CodeEditorVariablesPanel = require('./code-editor-variables-panel.js')
const CodeEditorPanel = require('./code-editor-panel.js')
module.exports = function CodeEditorContext (state, emit) {
  return [
    CodeEditorVariablesPanel(state, emit),
    CodeEditorPanel(state, emit)
  ]
}
